import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import useHirePortContext from '@/hooks/useHirePortContext';
import NotFoundIcon from '@/icons/404.svg?react';
import ErrorState from '@/UI/ErrorState/ErrorState';

const NotFound = ({
  message,
  fullPage = true,
}: {
  message?: string;
  fullPage?: boolean;
}) => {
  const [t] = useTranslation();
  const { homePath } = useHirePortContext();

  return (
    <ErrorState
      fullPage={fullPage}
      icon={<NotFoundIcon />}
      title={message || t('NOT_FOUND')}
      action={
        homePath ? (
          <Link to={homePath}>
            <Button>{t('BACK_TO_DASHBOARD')}</Button>
          </Link>
        ) : undefined
      }
    />
  );
};

export default NotFound;
